import { Theme } from '@mui/material';

import { getListComponents } from './list';
import { getDrawerComponent } from './drawer';
import { getTooltipComponents } from './tooltip';
import { getSurfaceComponents } from './surface';
import { getFormComponents } from './form';
import { getSelectComponents } from './select';
import { getNavigationComponents } from './navigation';
import { getButtonComponents } from './button';
import { getIconButtonComponents } from './iconButton';
import { getChipComponents } from './chip';
import { getDialogComponents } from './dialog';
import { getRadioComponents } from './radio';
import { getCheckboxComponents } from './checkbox';

export const getMuiComponents = (theme: Theme) => ({
  ...getListComponents(theme),
  ...getDrawerComponent(theme),
  ...getTooltipComponents(theme),
  ...getSurfaceComponents(theme),
  ...getFormComponents(theme),
  ...getSelectComponents(theme),
  ...getNavigationComponents(theme),
  ...getButtonComponents(theme),
  ...getIconButtonComponents(theme),
  ...getChipComponents(theme),
  ...getDialogComponents(theme),
  ...getRadioComponents(theme),
  ...getCheckboxComponents(theme),
});
